<template>
  <div class="page-home" ref="home">
    <!-- 开户资料待完善 -->
    <div v-show="!isHowHomePage" class="card-base card-shadow--small on-account-number" page_id="page_home">
      <el-steps :active="stepNumber" align-center>
        <!-- <el-step :title="$t('home.userStatus_title_one')" icon="el-icon-success"></el-step>
        <el-step :title="$t('home.userStatus_title_two')" icon="el-icon-success"></el-step> -->
        <!-- <el-step :title="$t('home.userStatus_title_three')" icon="el-icon-success"></el-step> -->
      </el-steps>
      <h2 v-show="userStatus == 'null'" v-html="$t('home.userStatus_description_one')"></h2>
      <h2 v-show="userStatus == 'unfinished'" v-html="$t('home.userStatus_description_two')"></h2>
      <h2 v-show="userStatus == 'review'" v-html="$t('home.userStatus_description_three')"></h2>
      <el-row class="QR-code">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="ai-jc ">
          <div class="ai-jc column">
            <img src="@/assets/images/ios-icon.png">
            <a href=" https://itunes.apple.com/cn/app/艾德金融/id1448584180?l=zh&ls=1&mt=8" target="_blank">
              <el-button class="ios-btn">
                {{$t('home.download')}}
              </el-button>
            </a>
          </div>
          <div class="ai-jc column">
            <img src="@/assets/images/Android-icon.png" class="hidden-md-and-down">
            <a href="https://www.eddid.com.hk/zh-hans/software2/" target="_blank">
              <el-button class="hidden-md-and-down android-btn">{{$t('home.download')}}</el-button>
            </a>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="hidden-lg-and-up ai-jc">
          <div class="ai-jc column">
            <img src="@/assets/images/Android-icon.png">
            <a href="https://www.eddid.com.hk/zh-hans/software2/" target="_blank">
              <el-button class="hidden-lg-and-up android-btn">{{$t('home.download')}}</el-button>
            </a>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 用户开户资料已通过审核 -->
    <div v-show="isHowHomePage" page_id="page_home">
      <!-- <bLoading :loading="allLoading"></bLoading> -->
      <div  class="card-base card-shadow--small select-account mt-20">
        <el-row :gutter="30" class="p-10 box-bod m-0">
          <!-- <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" > -->
          <el-col class="tit" :xs="{span: 24, offset: 1}" :sm="{span: 9, offset: 1}" :md="{span: 8, offset: 0}" :lg="{span: 9, offset:0.5}" :xl="{span: 9, offset: 1}">
            <h3 test_id="title_trade_account" class="select-trading-account" >{{$t('home.tradeAccount')}}</h3>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="30" class="m-0">
        <TradeAccountInfo ></TradeAccountInfo>
      </el-row>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pdfText from '@/js/openingAgreement.js'
import TradeAccountInfo from './tradeAccountInfo'
export default {
  props: [],
  components: {
    TradeAccountInfo
  },
  data () {
    return {
      pdfText: pdfText,
      checked: false,
      accountOpeningAgreement: '',
      dialogVisible: false,
      accountNum: '',
      accountTypeOption: [],
      balance: '0.00',
      equity: '0.00',
      parentList: [],
      loading: false,
      currency: '--',
      accountType: '--',
      currentNo: '',
      once: true,
      balanceList: [],
      type: '',
      userStatus: 'unprocessed',
      accountInfo: [],
      stepNumber: 1,
      loadingFailTip: '--',
      accountData: []
    }
  },
  computed: {
    ...mapGetters([
      'getUser',
      'getTransferAccountInfos',
      'valueAccountNumber',
      'accountNumbers',
      'getAllAccountInfo',
      'getAccountOpeningAgreement',
      'getAccountOpening'
    ]),
    // ...mapState(['accountBalance']),

    isHowHomePage () {
      if (this.getAccountOpening) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    accountBalance (newValue, oldValue) {
      if (newValue) {
        // this.formatData()
      }
    }
  },
  created () {
  },
  mounted () {
    // 验证用户开户状态
    // this.getUserStatus()
  },
  methods: {

    async getUserStatus () {
      this.$api.getUserStatus({
        idpUserId: this.$getProfile().sub
      }).then(result => {
        switch (result.data.status) {
          case 'notComplete':
            this.userStatus = 'unfinished'
            this.stepNumber = 2
            break
          case 'unprocessed':
            this.userStatus = 'unfinished'
            this.stepNumber = 2
            break
          case 'csApproval':
            this.userStatus = 'review'
            this.stepNumber = 3
            break
          case 'processing':
            this.userStatus = 'review'
            this.stepNumber = 3
            break
          case 'verifyPassed':
            this.userStatus = 'review'
            this.stepNumber = 3
            break
          case 'passed':
            this.userStatus = 'review'
            this.stepNumber = 3
            break
          case 'finish':
            this.userStatus = 'review'
            this.stepNumber = 3
            break
          case 'success':
            this.userStatus = 'review'
            this.stepNumber = 3
            break
          case 'refuse':
            this.userStatus = 'review'
            this.stepNumber = 3
            break
          default:
            this.userStatus = 'null'
            this.stepNumber = 1
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang = "scss">
.ios-btn,
.android-btn {
  margin: 20px 0;
  border-radius: 6px;
  border-color: #001e50;
  width: 100px;
  color: #001e50;
}
.confirmBtn {
  width: 50% !important;
  color: #001e50;
}
a {
  text-decoration: none;
}
.ai-jc {
  display: flex;
  align-items: center;
  justify-content: center;
}
.column {
  flex-direction: column;
}
.page-home {
  .tit {
    margin-left: 25px;
  }
}
.page-home .el-input__inner {
  font-family: PingFangSC-Semibold !important;
  font-size: 14px !important;
  font-weight: bold !important;
  color: #23282e !important;
  letter-spacing: 0 !important;
  background: #fff !important;
  border-radius: 5px !important;
}
.el-select .el-input .el-select__caret {
  color: #fec000 !important;
}
.select-account {
  background: #ffffff;
  box-shadow: 0 3px 7px 0 rgba(179, 179, 179, 0.5);
  border-radius: 5px;
}
.select-trading-account {
  font-family: Muli-Bold;
  font-size: 22px;
  color: #24282d;
  letter-spacing: 0.27px;
  line-height: 32px;
}
.box-bod {
  box-sizing: border-box !important;
}
.p-10 {
  padding: 10px;
}
.mt-20 {
  margin-top: 20px;
}
hr {
  border: 2px solid #eee;
  margin: 20px 0;
}
.el-select {
  width: 100%;
}
.account-info {
  margin-top: 30px;
  padding: 30px;
}
.left {
  font-family: Muli-Regular;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0.13px;
}
.right {
  font-family: Muli-Bold;
  font-size: 16px;
  color: #24282d;
  letter-spacing: 0.14px;
  text-align: right;
}
.on-account-number {
  background: #fff;
  padding-top: 20px;
  padding-bottom: 200px;
  margin-top: 20px;

  .el-step__title {
    color: #24282d;
  }
  h2 {
    padding: 40px 0;
    font-weight: normal;
    text-align: center;
  }
  .QR-code {
    text-align: center;
    img {
      border: 1px solid #e2e2e2;
      margin: 0 20px;
      display: inline-block;
    }
  }
}
.pt-10 {
  padding-top:10px;
}
.dialog-content {
  height: 400px;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.center {
  text-align: center;
  font-weight: 700;
}
.bold {
  font-weight: 700;
}
@media (max-width: 768px) {
  .layout-container .container .view {
    max-width: 100%;
    padding: 0;
    margin: 0;
  }
  .box-bod {
    margin: 0;
    padding-left: 0;
    padding-right: 0;
  }
  .select-trading-account {
    margin-bottom: 0;
  }
  .m-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .p-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>
